import { createStore } from "vuex";
import VuexPersist from "vuex-persist";

import currentUser from "./modules/currentUser.js";
import app from "./modules/app.js";

import entities from "./modules/Managment/Entities/entities.js";
import entitiesProfiles from "./modules/Managment/Entities/entitiesProfiles.js";
import entitiesEmails from "./modules/Managment/Entities/entitiesEmails.js";

import audit from "./modules/Managment/audit.js";

import pagesParams from "./modules/Subscribe/pagesParams.js";

import selfRegistration from "./modules/Subscribe/SelfRegistration.js";
import establishments from "./modules/Subscribe/Establishments.js";
import atuParams from "./modules/Subscribe/AtuParams.js";

const vuexPersist = new VuexPersist({
  key: "atu-app",
  storage: localStorage,
  reducer: (state) => ({
    app: state.app,
    selfRegistration: state.selfRegistration,
    establishments: state.establishments,
    atuParams: state.atuParams,
  }),
});

export default createStore({
  modules: {
    app,
    currentUser,

    entities,
    entitiesProfiles,
    entitiesEmails,

    audit,

    pagesParams,

    selfRegistration,
    establishments,
    atuParams,
  },
  plugins: [vuexPersist.plugin],
});
